import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import showdown from 'showdown';

@Component({
    selector: 'app-markdown-text',
    standalone: true,
    templateUrl: './markdown-text.component.html',
    styleUrls: ['./markdown-text.component.scss']
})
export class MarkdownTextComponent implements OnChanges {

    @Input() text: string;

    protected finalHTML: string;

    private _converter = new showdown.Converter();

    ngOnChanges(changes: SimpleChanges): void {
        this.finalHTML = this._converter.makeHtml(this.text ?? '')
    }


}
